/* PACKAGES */
import React from "react";
import ReactDOM from "react-dom/client";
/* APP */
import App from "./routes/routes";
import { Toaster } from "react-hot-toast";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
    <Toaster position="top-right"  duration={3000}/>
  </React.StrictMode>
);
